export default __webpack_public_path__ + "static/media/B40D.d34a3af1.jpg";